import { LANGUAGE } from '@common/constants/global.constants'
import { CertificationCourse } from '@common/enums/certification.enums'
import {
	CompanyCountry,
	CompanyType
} from '@common/enums/company.enums'
import { Status } from '@common/enums/global.enums'
import { Route } from '@config/routes/routes.enums'
import { flatten } from 'flat'

const messages = {
	global: {
		buttons: {
			apply: 'Applicare',
			cancel: 'Annullare',
			clear: 'Cancellare',
			confirm: 'Confermare',
			create: 'Creare',
			delete: 'Eliminare',
			download: 'Scaricare',
			export: 'Esportare',
			update: 'Aggiornare'
		},
		enums: {
			certificationCourse: {
				[CertificationCourse.HALF_DAY_SBEX_HIGH_PRESSURE]: 'Half-day SBEx High Pressure',
				[CertificationCourse.HALF_DAY_SBEX_LOW_PRESSURE]: 'Half-day SBEx Low Pressure',
				[CertificationCourse.SBEX_HIGH_PRESSURE]: 'SBEx High Pressure',
				[CertificationCourse.SBEX_LOW_PRESSURE]: 'SBEx Low Pressure',
				[CertificationCourse.SBEX_MPI]: 'SBEx Mpi',
				[CertificationCourse.SBEX_PHASTITE]: 'SBEx Phastite'
			},
			companyCountry: {
				[CompanyCountry.AFGHANISTAN]: 'Afghanistan',
				[CompanyCountry.ALBANIA]: 'Albania',
				[CompanyCountry.ALGERIA]: 'Algeria',
				[CompanyCountry.ANDORRA]: 'Andorra',
				[CompanyCountry.ANGOLA]: 'Angola',
				[CompanyCountry.ANTIGUA_AND_BARBUDA]: 'Antigua e Barbuda',
				[CompanyCountry.ARGENTINA]: 'Argentina',
				[CompanyCountry.ARMENIA]: 'Armenia',
				[CompanyCountry.AUSTRALIA]: 'Australia',
				[CompanyCountry.AUSTRIA]: 'Austria',
				[CompanyCountry.AZERBAIJAN]: 'Azerbaigian',
				[CompanyCountry.BAHAMAS]: 'Bahamas',
				[CompanyCountry.BAHRAIN]: 'Bahrein',
				[CompanyCountry.BANGLADESH]: 'Bangladesh',
				[CompanyCountry.BARBADOS]: 'Barbados',
				[CompanyCountry.BELARUS]: 'Bielorussia',
				[CompanyCountry.BELGIUM]: 'Belgio',
				[CompanyCountry.BELIZE]: 'Belize',
				[CompanyCountry.BENIN]: 'Benin',
				[CompanyCountry.BHUTAN]: 'Bhutan',
				[CompanyCountry.BOLIVIA]: 'Bolivia',
				[CompanyCountry.BOSNIA_AND_HERZEGOVINA]: 'Bosnia ed Erzegovina',
				[CompanyCountry.BOTSWANA]: 'Botswana',
				[CompanyCountry.BRAZIL]: 'Brasile',
				[CompanyCountry.BRUNEI]: 'Brunei',
				[CompanyCountry.BULGARIA]: 'Bulgaria',
				[CompanyCountry.BURKINA_FASO]: 'Burkina Faso',
				[CompanyCountry.BURUNDI]: 'Burundi',
				[CompanyCountry.CABO_VERDE]: 'Capo Verde',
				[CompanyCountry.CAMBODIA]: 'Cambogia',
				[CompanyCountry.CAMEROON]: 'Camerun',
				[CompanyCountry.CANADA]: 'Canada',
				[CompanyCountry.CENTRAL_AFRICAN_REPUBLIC]: 'Repubblica Centrafricana',
				[CompanyCountry.CHAD]: 'Ciad',
				[CompanyCountry.CHILE]: 'Cile',
				[CompanyCountry.CHINA]: 'Cina',
				[CompanyCountry.COLOMBIA]: 'Colombia',
				[CompanyCountry.COMOROS]: 'Comore',
				[CompanyCountry.CONGO]: 'Congo',
				[CompanyCountry.COSTA_RICA]: 'Costa Rica',
				[CompanyCountry.CROATIA]: 'Croazia',
				[CompanyCountry.CUBA]: 'Cuba',
				[CompanyCountry.CYPRUS]: 'Cipro',
				[CompanyCountry.CZECH_REPUBLIC]: 'Repubblica Ceca',
				[CompanyCountry.DEMOCRATIC_REPUBLIC_OF_THE_CONGO]: 'Repubblica Democratica del Congo',
				[CompanyCountry.DENMARK]: 'Danimarca',
				[CompanyCountry.DJIBOUTI]: 'Gibuti',
				[CompanyCountry.DOMINICA]: 'Dominica',
				[CompanyCountry.DOMINICAN_REPUBLIC]: 'Repubblica Dominicana',
				[CompanyCountry.ECUADOR]: 'Ecuador',
				[CompanyCountry.EGYPT]: 'Egitto',
				[CompanyCountry.EL_SALVADOR]: 'El Salvador',
				[CompanyCountry.EQUATORIAL_GUINEA]: 'Guinea Equatoriale',
				[CompanyCountry.ERITREA]: 'Eritrea',
				[CompanyCountry.ESTONIA]: 'Estonia',
				[CompanyCountry.ESWATINI]: 'Eswatini',
				[CompanyCountry.ETHIOPIA]: 'Etiopia',
				[CompanyCountry.FIJI]: 'Figi',
				[CompanyCountry.FINLAND]: 'Finlandia',
				[CompanyCountry.FRANCE]: 'Francia',
				[CompanyCountry.GABON]: 'Gabon',
				[CompanyCountry.GAMBIA]: 'Gambia',
				[CompanyCountry.GEORGIA]: 'Georgia',
				[CompanyCountry.GERMANY]: 'Germania',
				[CompanyCountry.GHANA]: 'Ghana',
				[CompanyCountry.GREECE]: 'Grecia',
				[CompanyCountry.GRENADA]: 'Grenada',
				[CompanyCountry.GUATEMALA]: 'Guatemala',
				[CompanyCountry.GUINEA]: 'Guinea',
				[CompanyCountry.GUINEA_BISSAU]: 'Guinea-Bissau',
				[CompanyCountry.GUYANA]: 'Guyana',
				[CompanyCountry.HAITI]: 'Haiti',
				[CompanyCountry.HONDURAS]: 'Honduras',
				[CompanyCountry.HUNGARY]: 'Ungheria',
				[CompanyCountry.ICELAND]: 'Islanda',
				[CompanyCountry.INDIA]: 'India',
				[CompanyCountry.INDONESIA]: 'Indonesia',
				[CompanyCountry.IRAN]: 'Iran',
				[CompanyCountry.IRAQ]: 'Iraq',
				[CompanyCountry.IRELAND]: 'Irlanda',
				[CompanyCountry.ISRAEL]: 'Israele',
				[CompanyCountry.ITALY]: 'Italia',
				[CompanyCountry.JAMAICA]: 'Giamaica',
				[CompanyCountry.JAPAN]: 'Giappone',
				[CompanyCountry.JORDAN]: 'Giordania',
				[CompanyCountry.KAZAKHSTAN]: 'Kazakistan',
				[CompanyCountry.KENYA]: 'Kenya',
				[CompanyCountry.KIRIBATI]: 'Kiribati',
				[CompanyCountry.KUWAIT]: 'Kuwait',
				[CompanyCountry.KYRGYZSTAN]: 'Kirghizistan',
				[CompanyCountry.LAOS]: 'Laos',
				[CompanyCountry.LATVIA]: 'Lettonia',
				[CompanyCountry.LEBANON]: 'Libano',
				[CompanyCountry.LESOTHO]: 'Lesotho',
				[CompanyCountry.LIBERIA]: 'Liberia',
				[CompanyCountry.LIBYA]: 'Libia',
				[CompanyCountry.LIECHTENSTEIN]: 'Liechtenstein',
				[CompanyCountry.LITHUANIA]: 'Lituania',
				[CompanyCountry.LUXEMBOURG]: 'Lussemburgo',
				[CompanyCountry.MADAGASCAR]: 'Madagascar',
				[CompanyCountry.MALAWI]: 'Malawi',
				[CompanyCountry.MALAYSIA]: 'Malesia',
				[CompanyCountry.MALDIVES]: 'Maldive',
				[CompanyCountry.MALI]: 'Mali',
				[CompanyCountry.MALTA]: 'Malta',
				[CompanyCountry.MARSHALL_ISLANDS]: 'Isole Marshall',
				[CompanyCountry.MAURITANIA]: 'Mauritania',
				[CompanyCountry.MAURITIUS]: 'Maurizio',
				[CompanyCountry.MEXICO]: 'Messico',
				[CompanyCountry.MICRONESIA]: 'Micronesia',
				[CompanyCountry.MOLDOVA]: 'Moldavia',
				[CompanyCountry.MONACO]: 'Monaco',
				[CompanyCountry.MONGOLIA]: 'Mongolia',
				[CompanyCountry.MONTENEGRO]: 'Montenegro',
				[CompanyCountry.MOROCCO]: 'Marocco',
				[CompanyCountry.MOZAMBIQUE]: 'Mozambico',
				[CompanyCountry.MYANMAR]: 'Myanmar',
				[CompanyCountry.NAMIBIA]: 'Namibia',
				[CompanyCountry.NAURU]: 'Nauru',
				[CompanyCountry.NEPAL]: 'Nepal',
				[CompanyCountry.NETHERLANDS]: 'Paesi Bassi',
				[CompanyCountry.NEW_ZEALAND]: 'Nuova Zelanda',
				[CompanyCountry.NICARAGUA]: 'Nicaragua',
				[CompanyCountry.NIGER]: 'Niger',
				[CompanyCountry.NIGERIA]: 'Nigeria',
				[CompanyCountry.NORTH_KOREA]: 'Corea del Nord',
				[CompanyCountry.NORTH_MACEDONIA]: 'Macedonia del Nord',
				[CompanyCountry.NORWAY]: 'Norvegia',
				[CompanyCountry.OMAN]: 'Oman',
				[CompanyCountry.PAKISTAN]: 'Pakistan',
				[CompanyCountry.PALAU]: 'Palau',
				[CompanyCountry.PALESTINE]: 'Palestina',
				[CompanyCountry.PANAMA]: 'Panama',
				[CompanyCountry.PAPUA_NEW_GUINEA]: 'Papua Nuova Guinea',
				[CompanyCountry.PARAGUAY]: 'Paraguay',
				[CompanyCountry.PERU]: 'Perù',
				[CompanyCountry.PHILIPPINES]: 'Filippine',
				[CompanyCountry.POLAND]: 'Polonia',
				[CompanyCountry.PORTUGAL]: 'Portogallo',
				[CompanyCountry.QATAR]: 'Qatar',
				[CompanyCountry.ROMANIA]: 'Romania',
				[CompanyCountry.RUSSIA]: 'Russia',
				[CompanyCountry.RWANDA]: 'Ruanda',
				[CompanyCountry.SAINT_KITTS_AND_NEVIS]: 'Saint Kitts e Nevis',
				[CompanyCountry.SAINT_LUCIA]: 'Santa Lucia',
				[CompanyCountry.SAINT_VINCENT_AND_THE_GRENADINES]: 'Saint Vincent e Grenadine',
				[CompanyCountry.SAMOA]: 'Samoa',
				[CompanyCountry.SAN_MARINO]: 'San Marino',
				[CompanyCountry.SAO_TOME_AND_PRINCIPE]: 'São Tomé e Príncipe',
				[CompanyCountry.SAUDI_ARABIA]: 'Arabia Saudita',
				[CompanyCountry.SENEGAL]: 'Senegal',
				[CompanyCountry.SERBIA]: 'Serbia',
				[CompanyCountry.SEYCHELLES]: 'Seychelles',
				[CompanyCountry.SIERRA_LEONE]: 'Sierra Leone',
				[CompanyCountry.SINGAPORE]: 'Singapore',
				[CompanyCountry.SLOVAKIA]: 'Slovacchia',
				[CompanyCountry.SLOVENIA]: 'Slovenia',
				[CompanyCountry.SOLOMON_ISLANDS]: 'Isole Salomone',
				[CompanyCountry.SOMALIA]: 'Somalia',
				[CompanyCountry.SOUTH_AFRICA]: 'Sudafrica',
				[CompanyCountry.SOUTH_KOREA]: 'Corea del Sud',
				[CompanyCountry.SOUTH_SUDAN]: 'Sudan del Sud',
				[CompanyCountry.SPAIN]: 'Spagna',
				[CompanyCountry.SRI_LANKA]: 'Sri Lanka',
				[CompanyCountry.SUDAN]: 'Sudan',
				[CompanyCountry.SURINAME]: 'Suriname',
				[CompanyCountry.SWEDEN]: 'Svezia',
				[CompanyCountry.SWITZERLAND]: 'Svizzera',
				[CompanyCountry.SYRIA]: 'Siria',
				[CompanyCountry.TAIWAN]: 'Taiwan',
				[CompanyCountry.TAJIKISTAN]: 'Tagikistan',
				[CompanyCountry.TANZANIA]: 'Tanzania',
				[CompanyCountry.THAILAND]: 'Thailandia',
				[CompanyCountry.TIMOR_LESTE]: 'Timor-Leste',
				[CompanyCountry.TOGO]: 'Togo',
				[CompanyCountry.TONGA]: 'Tonga',
				[CompanyCountry.TRINIDAD_AND_TOBAGO]: 'Trinidad e Tobago',
				[CompanyCountry.TUNISIA]: 'Tunisia',
				[CompanyCountry.TURKEY]: 'Turchia',
				[CompanyCountry.TURKMENISTAN]: 'Turkmenistan',
				[CompanyCountry.TUVALU]: 'Tuvalu',
				[CompanyCountry.UGANDA]: 'Uganda',
				[CompanyCountry.UKRAINE]: 'Ucraina',
				[CompanyCountry.UNITED_ARAB_EMIRATES]: 'Emirati Arabi Uniti',
				[CompanyCountry.UNITED_KINGDOM]: 'Regno Unito',
				[CompanyCountry.UNITED_STATES_OF_AMERICA]: 'Stati Uniti d’America',
				[CompanyCountry.URUGUAY]: 'Uruguay',
				[CompanyCountry.UZBEKISTAN]: 'Uzbekistan',
				[CompanyCountry.VANUATU]: 'Vanuatu',
				[CompanyCountry.VATICAN_CITY]: 'Città del Vaticano',
				[CompanyCountry.VENEZUELA]: 'Venezuela',
				[CompanyCountry.VIETNAM]: 'Vietnam',
				[CompanyCountry.YEMEN]: 'Yemen',
				[CompanyCountry.ZAMBIA]: 'Zambia',
				[CompanyCountry.ZIMBABWE]: 'Zimbabwe'
			},
			companyType: {
				[CompanyType.DISTRIBUTOR]: 'Distributore',
				[CompanyType.DIVISION]: 'Divisione',
				[CompanyType.END_USER]: 'Utente finale',
				[CompanyType.SALES_COMPANY]: 'Sales Co'
			},
			status: {
				[Status.ACTIVE]: 'Attivo',
				[Status.INACTIVE]: 'Inattivo',
				[Status.DELETED]: 'Eliminare'
			}
		},
		errorPages: {
			forbidden: {
				code: '403',
				message: 'Pagina vietata',
				explanation: 'La pagina che stai cercando non è accessibile.'
			},
			notFound: {
				code: '404',
				message: 'Pagina non trovata',
				explanation: 'La pagina che stai cercando non esiste o non è disponibile al momento.'
			},
			unauthorized: {
				code: '401',
				message: 'Non autorizzato',
				explanation: 'Non sei autorizzato ad accedere alla pagina richiesta.'
			}
		},
		errors: {
			certificationAlreadyCreated: 'Certificazione già creata per questo discente',
			emailAlreadyUsed: 'E-mail già utilizzata. Deve essere univoca',
			occurred: 'Si è verificato un errore',
			pattern: 'Formato non corretto',
			required: 'Campo obbligatorio',
			traineeHasNoEmail: 'Un formatore deve avere un indirizzo e-mail'
		},
		fields: {
			company: 'Azienda',
			country: 'Paese',
			course: 'Corso',
			email: 'E-mail',
			firstname: 'Nome',
			lastname: 'Cognome',
			name: 'Nome',
			status: 'Stato',
			trainer: 'Formatore',
			type: 'Categoria'
		},
		lang: LANGUAGE,
		tabs: {
			[Route.DASHBOARD]: 'Dashboard SBEx',
			[Route.TRAINEES]: 'Gestione dei corsisti SBEx',
			[Route.ANALYTICS]: 'SBEx analytics'
		}
	},
	components: {
		certificationPopIn: {
			creation: {
				title: 'Nuova certificazione',
				subtitle: 'Inserisci i dettagli della formazione per generare la certificazione.',
				buttons: {
					confirm: {
						label: 'Crea la certificazione'
					}
				},
				success: 'La certificazione è stata creata'
			},
			fields: {
				trainer: {
					placeholder: 'Seleziona un formatore',
					noData: 'Nessun formatore attivo'
				},
				course: {
					placeholder: 'Selezionare un corso'
				},
				isTrainer: {
					label: 'Ottenere come formatore'
				},
				date: {
					label: 'Data della formazione',
					placeholder: 'Selezionare una data'
				}
			}
		}
	},
	dashboard: {
		expiringCertifications: {
			title: '<a><b>{count} {count, plural, =0 {certificazione} one {certificazione} other {certificazioni}} {count, plural, =0 {in scadenza} one {in scadenza} other {in scadenza}} </b><c>(tra 3 mesi o meno)</c></a>',
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				trainer: 'Formatore',
				date: 'Scade il {date}',
				discardButton: {
					label: 'Eliminare',
					success: 'La notifica è stata eliminata'
				},
				noData: 'Nessuna certificazione in scadenza'
			}
		},
		trainees: {
			title: 'Gestione dei corsisti',
			actions: {
				addTrainee: {
					label: 'Nuovo corsista',
					title: 'Nuovo corsista',
					subtitle: 'Aggiungi un corsista per poter rilasciargli una certificazione.',
					fields: {
						email: {
							label: 'Email (obbligatoria per i formatori)'
						},
						company: {
							placeholder: 'Seleziona un’azienda'
						}
					},
					buttons: {
						create: 'Crea un corsista',
						createWithCertification: 'Crea un corsista e aggiungi una certificazione'
					},
					success: 'Il corsista è stato creato'
				},
				addCompany: {
					title: 'Seleziona un’azienda',
					subtitle: 'Cerca l’azienda del corsista oppure aggiungila se non è presente nell’elenco.',
					filters: {
						query: {
							placeholder: 'Inserisci il nome di un’azienda.'
						}
					},
					links: {
						createCompany: '<a><b>L’azienda non esiste?</b> <c><b>Clicca qui per crearla</b></c></a>'
					},
					noData: 'Nessuna azienda'
				},
				createCompany: {
					title: 'Nuova azienda',
					subtitle: 'Crea una nuova azienda da utilizzare per la creazione dei corsisti.',
					fields: {
						type: {
							placeholder: 'Seleziona la categoria dell’azienda'
						},
						country: {
							placeholder: 'Seleziona un paese'
						},
						name: {
							placeholder: 'Nome dell’azienda'
						}
					},
					buttons: {
						confirm: {
							label: 'Crea l’azienda'
						}
					},
					success: 'L’azienda è stata creata'
				}
			},
			filters: {
				company: 'Seleziona un’azienda',
				companiesNotFound: 'Nessuna azienda trovata',
				query: 'Nome, e-mail o numero di certificato',
				advanced: {
					title: 'Filtri avanzati',
					subtitle: 'Filtra le certificazioni per formazione e/o per intervallo di date.',
					course: {
						title: 'Formazione',
						select: 'Seleziona una formazione'
					},
					startDate: 'Data di formazione a partire dal',
					endDate: 'Fino al'
				}
			},
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				actions: {
					viewUpdate: {
						label: 'Visualizza e aggiorna'
					},
					addCertification: {
						label: 'Aggiungi una certificazione'
					}
				},
				noData: 'Nessun corsista'
			}
		},
		tooltips: {
			viewTraineeDetails: 'Usa CTRL+clic per visualizzare i dettagli del corsista in una nuova scheda'
		}
	},
	trainee: {
		information: {
			buttons: {
				save: {
					label: 'Salva le modifiche',
					success: 'Le informazioni del corsista sono state salvate'
				},
				delete: {
					title: 'Elimina il corsista',
					message: 'Confermi l’eliminazione del corsista?',
					success: 'Il corsista è stato eliminato'
				}
			}
		},
		certifications: {
			header: {
				title: 'Certificazioni'
			},
			actions: {
				create: {
					label: 'Nuova certificazione'
				},
				update: {
					title: 'Modifica la certificazione',
					subtitle: 'Verifica e modifica le informazioni prima di generare la certificazione.',
					buttons: {
						confirm: {
							label: 'Salva le modifiche'
						}
					},
					success: 'La certificazione è stata aggiornata'
				},
				delete: {
					title: 'Elimina la certificazione',
					message: 'Confermi l’eliminazione della certificazione?',
					success: 'La certificazione è stata eliminata'
				}
			},
			list: {
				trainer: 'Formatore',
				training: 'Formato il {date} da {trainer} / {company}',
				expiringDate: 'Scade il {date}',
				noData: 'Nessuna certificazione',
				download: {
					label: 'Scarica il certificato'
				}
			}
		}
	},
	analytics: {
		title: 'Dati analitici',
		inputs: {
			startDate: {
				label: 'Selezione della data di inizio'
			},
			endDate: {
				label: 'Selezione della data di fine'
			}
		}
	}
}

const appMessages: Record<string, string> = flatten(messages)

export default appMessages
